import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useDialogSelector = () => useSelector((state: StateExtended) => state.dialog.dialog);
